'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwError = exports.createDummyController = exports.View = exports.parallel = exports.sequence = exports.Compute = exports.Provider = exports.CerebralError = exports.ProviderClass = exports.ControllerClass = exports.ModuleClass = undefined;

var _Module = require('./Module');

Object.defineProperty(exports, 'ModuleClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Module).default;
  }
});

var _Controller = require('./Controller');

Object.defineProperty(exports, 'ControllerClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Controller).default;
  }
});

var _Provider = require('./Provider');

Object.defineProperty(exports, 'ProviderClass', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Provider).default;
  }
});
exports.BaseController = BaseController;
exports.Controller = Controller;
exports.UniversalController = UniversalController;
exports.Module = Module;

var _CerebralError = require('./CerebralError');

Object.defineProperty(exports, 'CerebralError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CerebralError).default;
  }
});
Object.defineProperty(exports, 'Provider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Provider).default;
  }
});

var _Compute = require('./Compute');

Object.defineProperty(exports, 'Compute', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Compute).default;
  }
});

var _functionTree = require('function-tree');

Object.defineProperty(exports, 'sequence', {
  enumerable: true,
  get: function get() {
    return _functionTree.sequence;
  }
});
Object.defineProperty(exports, 'parallel', {
  enumerable: true,
  get: function get() {
    return _functionTree.parallel;
  }
});

var _View = require('./View');

Object.defineProperty(exports, 'View', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_View).default;
  }
});

var _utils = require('./utils');

Object.defineProperty(exports, 'createDummyController', {
  enumerable: true,
  get: function get() {
    return _utils.createDummyController;
  }
});
Object.defineProperty(exports, 'throwError', {
  enumerable: true,
  get: function get() {
    return _utils.throwError;
  }
});

var _BaseController = require('./BaseController');

var _BaseController2 = _interopRequireDefault(_BaseController);

var _Controller2 = _interopRequireDefault(_Controller);

var _UniversalController = require('./UniversalController');

var _UniversalController2 = _interopRequireDefault(_UniversalController);

var _Module2 = _interopRequireDefault(_Module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseController(rootModule, options) {
  return new _BaseController2.default(rootModule, options);
}

function Controller(rootModule, options) {
  return new _Controller2.default(rootModule, options);
}

function UniversalController(rootModule, options) {
  return new _UniversalController2.default(rootModule, options);
}

function Module(definition) {
  return new _Module2.default(definition);
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/index.js
// module id = 225
// module chunks = 0